export default __webpack_public_path__ + "static/media/KM.cf3e8a00.svg";